import React, { useCallback, useState } from 'react';
import classNames from 'classnames';

import { UiButton } from 'src/components/UI/Button';
import { BrandingModelSelectorType } from 'src/models/Branding/BrandingModel';
import { useRefClickOutside } from 'src/utils/hooks/useRefClickOutside';
import { HeaderUserSigninPopupComponent } from './UserSignInPopup';

type NonAuthenticatedUserProps = {
  brandingModel: BrandingModelSelectorType;
  partnerName: string | null;
};

export const HeaderNonAuthenticatedUserIcon: React.FC<NonAuthenticatedUserProps> = ({
  brandingModel,
  partnerName,
}: NonAuthenticatedUserProps) => {
  const [popupShown, setPopupShown] = useState(false);

  const togglePopover = useCallback(() => {
    setPopupShown((v) => !v);
  }, []);

  const hidePopover = useCallback(() => {
    setPopupShown(false);
  }, []);

  const ref = useRefClickOutside<HTMLLIElement>(popupShown, hidePopover);

  return (
    <li ref={ref} className="sign-in">
      <UiButton tag="a" className="header-user-info hoverable HeaderIconColorBg" onClick={togglePopover} effects>
        <i className="material-icons" style={{ color: brandingModel.data.BackColor }}>
          person
        </i>
      </UiButton>
      <div
        className={classNames(
          // eslint-disable-next-line max-len
          'popover fade bottom popover-wrapper not-custom-branding-popover user-popover open-user-icon-popover anonymous-popover',
          {
            in: popupShown,
          }
        )}
      >
        <div className="arrow" />
        <HeaderUserSigninPopupComponent partnerName={partnerName} onClose={hidePopover} />
      </div>
    </li>
  );
};
